import { useCallback, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { css } from '@emotion/react';
import { getUser } from '@frontend/auth-helpers';
import { useTranslation } from '@frontend/i18n';
import { pendo } from '@frontend/tracking';
import { theme } from '@frontend/theme';
import { Heading, Text } from '@frontend/design-system';

export const ExpandModeNudge = () => {
  const DOM_CONTAINER = document.body;
  const { t } = useTranslation('settings');
  const [closeNudge, setCloseNudge] = useState<boolean>(false);
  const isWindows = window?.shell?.isWindows;
  const isLinux = window?.shell?.isLinux;
  const leftSideNudge = isWindows || isLinux;
  const closeHandler = useCallback(() => {
    setCloseNudge(true);
  }, []);
  const userID = getUser()?.userID || '';

  useEffect(() => {
    pendo.track('compact_mode_onboarding_nudge_seen', {
      userId: userID,
      timestamp: new Date().toISOString(),
    });
  }, [userID]);

  if (closeNudge) {
    return null;
  }
  return createPortal(
    <>
      <div css={[styles.nudge, leftSideNudge && styles.leftNudge]}>
        <div css={[styles.arrow, leftSideNudge && styles.leftArrow]} />
        <div style={{ textAlign: 'center' }}>
          <Heading level={3} css={styles.heading}>
            {t('Click Here To Expand')}
          </Heading>
          <Text>{t('Ideal for analytics and detailed scheduling work')}</Text>
        </div>
      </div>
      <div css={styles.blurBackground} onClick={closeHandler} />
    </>,
    DOM_CONTAINER
  );
};

const BACKGROUND_Z_INDEX = 10000;

const styles = {
  nudge: css`
    position: fixed;
    top: ${theme.spacing(1.25)};
    right: ${theme.spacing(0.5)};
    background: ${theme.colors.white};
    padding: ${theme.spacing(2)};
    border-radius: ${theme.spacing(1.25)};
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
    width: 260px;
    z-index: ${BACKGROUND_Z_INDEX + 1};
  `,
  leftNudge: css`
    left: ${theme.spacing(0.5)};
  `,
  arrow: css`
    position: fixed;
    top: ${theme.spacing(0.5)};
    right: ${theme.spacing(2.5)};
    width: 12px;
    height: 12px;
    background: ${theme.colors.white};
    transform: rotate(45deg);
  `,
  leftArrow: css`
    left: 145px;
  `,
  heading: css`
    margin-bottom: ${theme.spacing(1)};
    text-align: center;
  `,
  blurBackground: css`
    position: fixed;
    top: 0;
    left: 0;
    background: ${theme.colors.black};
    opacity: 0.5;
    height: 100vh;
    width: 100vw;
    z-index: ${BACKGROUND_Z_INDEX};
  `,
};
